module.exports = __webpack_public_path__ + "static/media/stijn-bessem-clients-chunk.d080dc0b.svg";